import styled, { keyframes } from 'styled-components';
import { LogoBadge as LMFLogoBadge } from '../Icons';
export const Wrapper = styled.div `
  display: inline-flex;
  justify-content: center;
  align-items: center;
  position: relative;
  width: ${({ size }) => size};
  height: ${({ size }) => size};
`;
export const LogoBadge = styled(LMFLogoBadge) `
  position: absolute;
  display: inline-block;
  height: 42.5%;
  width: auto;
`;
const spin = keyframes `
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }`;
export const SpinnerOverlay = styled.div `
  display: inline-block;
  animation: ${spin} 1s linear infinite;
  border: 2px solid #f5f5f5;
  border-top-color: #000;
  border-radius: 50%;
  top: 0;
  left: 0;
  width: 100%;
  aspect-ratio: 1;
  z-index: 0;
`;
//# sourceMappingURL=styles.js.map